import { render, staticRenderFns } from "./courseResult.vue?vue&type=template&id=b5703d32&scoped=true&"
import script from "./courseResult.vue?vue&type=script&lang=js&"
export * from "./courseResult.vue?vue&type=script&lang=js&"
import style0 from "./courseResult.vue?vue&type=style&index=0&id=b5703d32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5703d32",
  null
  
)

export default component.exports